module.exports = __webpack_public_path__ + "img/9f75b43.png";